"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SUPER_ADMIN = exports.REGISTERED = exports.MODERATOR = exports.GUEST = exports.COMMUNITY_MANAGER = exports.ADMINISTRATOR = void 0;
exports.canLoginUserEditPost = canLoginUserEditPost;
exports.canUserEditPost = canUserEditPost;
exports.isCommunityManager = isCommunityManager;
exports.isEditTimeExpired = isEditTimeExpired;

var _insidedDataStorage = require("@insided/shared/utils/insidedDataStorage");

var SUPER_ADMIN = 'roles.super-admin';
exports.SUPER_ADMIN = SUPER_ADMIN;
var ADMINISTRATOR = 'roles.administrator';
exports.ADMINISTRATOR = ADMINISTRATOR;
var COMMUNITY_MANAGER = 'roles.community-manager';
exports.COMMUNITY_MANAGER = COMMUNITY_MANAGER;
var MODERATOR = 'roles.moderator';
exports.MODERATOR = MODERATOR;
var REGISTERED = 'roles.registered';
exports.REGISTERED = REGISTERED;
var GUEST = 'roles.guest';
exports.GUEST = GUEST;

function canUserEditPost() {
  if (typeof window === 'undefined') return false;

  var _getInsidedData = (0, _insidedDataStorage.getInsidedData)('user'),
      mainRole = _getInsidedData.mainRole;

  return [ADMINISTRATOR, MODERATOR, SUPER_ADMIN].includes(mainRole);
}

function isCommunityManager(role) {
  return [COMMUNITY_MANAGER, ADMINISTRATOR, SUPER_ADMIN].includes(role);
}

function canLoginUserEditPost(authorId, postId, creationDate, unlimitedEditPermission) {
  if (typeof window === 'undefined') return false;

  var _getInsidedData2 = (0, _insidedDataStorage.getInsidedData)('user'),
      mainRole = _getInsidedData2.mainRole,
      isModerator = _getInsidedData2.isModerator,
      userid = _getInsidedData2.userid;

  if ([COMMUNITY_MANAGER, MODERATOR, ADMINISTRATOR, SUPER_ADMIN].includes(mainRole)) {
    return true;
  }

  if (isModerator || postId === null || unlimitedEditPermission && authorId.toString() === userid.toString()) {
    return true;
  }

  if (!authorId || (authorId === null || authorId === void 0 ? void 0 : authorId.toString()) !== (userid === null || userid === void 0 ? void 0 : userid.toString())) {
    return false;
  }

  return !isEditTimeExpired(creationDate);
}

function isEditTimeExpired(creationDate) {
  var defaultEditPostTime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 60;
  var expirationTimeStamp = Date.parse(creationDate) + defaultEditPostTime * 60 * 1000;
  var nowTimeStamp = Date.now();
  return nowTimeStamp > expirationTimeStamp;
}